import moment from 'moment-timezone';
import { useAppContext } from '@/context';
import { AppConstants } from '@/utils/constants';

const useMomentWithTimezone = () => {
  const { user } = useAppContext();
  const timezone =
    user?.options?.timezone || AppConstants.timezone.defaultTimezone;
  return (inputTime?: any) => {
    if (!inputTime) return moment().tz(timezone).format('YYYY/MM/DD HH:mm:ss');
    return moment.utc(inputTime).tz(timezone).format('YYYY/MM/DD HH:mm:ss');
  };
};

export default useMomentWithTimezone;
